import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const NewsletterSignupBase = styled.div`
  background-color: ${theme.colors.blues[10]};
`;

export const NewsletterSignupContent = styled.div``;

export const NewsletterText = styled.h2``;

export const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: ${theme.spacing[4]};
  align-content: flex-start;
`;

export const InputLabel = styled.h6`
  font-weight: ${theme.fontWeights.semibold};
`;

export const Disclaimer = styled.div`
  font-size: ${theme.fontSizes[0]};
  color: ${theme.colors.darkBlues[50]};

  a {
    color: ${theme.colors.blues[100]};
  }
`;
